import { render } from "./HomeUsersIcon.vue?vue&type=template&id=114824e0"
import script from "./HomeUsersIcon.vue?vue&type=script&lang=js"
export * from "./HomeUsersIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__